import { User } from "@/base/model/user";
import { Client } from "../../service/client";

export class UserApi {
  private client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  async add({ email }: { email: string }): Promise<User> {
    const response = await this.client.fetch(`/auth/user`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });

    const json = await response.json();

    return json.data as User;
  }

  async getMe(): Promise<User | null> {
    const response = await this.client.fetch(`/auth/user`);

    const json = await response.json();

    return json.data as User;
  }

  async patch(user: Partial<User>): Promise<User> {
    const response = await this.client.fetch(`/auth/user`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(user),
    });

    const json = await response.json();

    return json.user as User;
  }

  async uploadPicture(formData: FormData): Promise<void> {
    await this.client.fetch(`/auth/user/picture`, {
      method: "POST",
      body: formData,
    });
  }

  async sendEmailVerification(email: string): Promise<void> {
    await this.client.fetch(`/auth/send-email-verification`, {
      method: "POST",
      body: JSON.stringify({ email }),
    });
  }

  async logout(): Promise<void> {
    await this.client.fetch(`/auth/logout`, {
      method: "POST",
    });
  }

  async deleteAccount(): Promise<void> {
    await this.client.fetch(`/auth/user`, {
      method: "DELETE",
    });
  }
}
